module.exports = __webpack_public_path__ + "img/Step2@2x.793c0104.jpg";